module.exports = __webpack_public_path__ + "img/drizzle.8a1fb79c.jpg";